import { fetchAPI } from "@/api/api"

const FINGERPRINT_PRO_TRACKER_API_URL =
  "/exchange/member/playerService/fingerprintProTracker"

export interface FingerprintProTrackerPayload {
  eventId?: string
  publicKey?: string
  errorMsg?: string
}

const fetch = {
  url: FINGERPRINT_PRO_TRACKER_API_URL,
  handler: async (data: FingerprintProTrackerPayload) =>
    fetchAPI({
      url: FINGERPRINT_PRO_TRACKER_API_URL,
      data
    })
}

export default fetch
